import React, { useEffect, useState } from "react";
import TopBanner from "../../../../components/common/topbanner";
import AdminDataTable from "../../../AdminPages/Component/Common/admin-datatable";
import Tabs from "./Tabs";
import { useTranslation } from "react-i18next";
import Select from "../../../../components/common/select";
import { API_RESPONSE } from "../../../../utils/app-constants";
import { getAllHospitalList, getDistrict, getState } from "../../../../hooks/services/api-services";
import { toastEmitter } from "../../../../utils/utilities";
import { handleFormInput } from "../../../../utils/form-utils";
import RecordNotfound from "../Common/recordNotfound";
const PmHospital = () => {
  const [allState, setAllState] = useState([]);
  const [allDistrict, setAllDistrict] = useState([]);
  const [stateName, setStateName] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalElement, settotalElement] = useState();
  const [isSearchTriggered, setIsSearchTriggered] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [pending, setPending] = useState(true);
  const [payload, setPayload] = useState({
    pageIndex: page,
    pageSize: pageSize,
    hsplType: "",
    state: "",
    district: ""
  });

  const getAllState = async () => {
    try {
      const response = await getState();
      if (response?.data?.responseCode == 200) {
        setAllState(response?.data?.data);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };


  const getAllDistrict = async () => {
    try {
      const response = await getDistrict(stateName);
      if (response?.data?.responseCode == 200) {
        setAllDistrict(response?.data?.data);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };
  useEffect(() => {
    if (stateName) {
      getAllDistrict()
    }
  }, [stateName])

  const handleSelect = (e) => {
    setIsSearchTriggered(false)
    const stateId = allState?.filter(v => v?.stateNameInEnglish == e.target.value)
    setStateName(stateId?.[0]?.stateCode);
    setPayload(handleFormInput(e, payload));
    if (e.target.name == "state") {
      if (e.target.value == 0) {
        setAllDistrict([])
        setPayload({ ...payload, district: "", state: "", })
      }
    }
  }

  useEffect(() => {
    getAllState();
  }, [])

  const handleSerach = () => {
    getAllHospitalListData();
  }

  const getAllHospitalListData = async () => {
    try {
      setPending(true)
      const response = await getAllHospitalList(payload);
      if (response?.data?.responseCode === 200) {
        setRowData(response?.data?.responseBody?.hospitalResponseList || []);
        settotalElement(response?.data?.responseBody?.totalElement)
        setPending(false)

      } else {
        console.log("Error=>", response?.data?.message);
        setRowData([]);
        setPending(false)
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setPending(false)
    }
  };

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#283779",
        fontSize: "16px",
        padding: "3px",
        backgroundColor: "#EBE8FF",
        borderRadius: "15px",
      },
    },
    rows: {
      style: {
        color: "#18100F",
        fontSize: "16px",
        padding: "4px",
        boxSizing: "border-box",
        border: "1px solid #8C7CFF",
        marginTop: "10px",
        borderRadius: "15px",
      },
    },
  };

  const createPayload = () => {
    if (setPayload && (page || pageSize)) {
      let payloadData = {
        pageIndex: page,
        pageSize: pageSize,
        hsplType: payload?.hsplType,
        state: payload?.state,
        district: payload?.district
      };
      setPayload({ ...payloadData });
    }
  }

  useEffect(() => {
    createPayload();
  }, [page, pageSize]);


  useEffect(() => {
    if (isSearchTriggered) {
      getAllHospitalListData();
    }
  }, [payload])
  
  const tblColumns = [
    {
      code: "Sr.No",
      name: "Sr.No",
      width: "80px",
      // omit: true,
      sortable: false,
      selector: (row) => `${row?.serialNo}`,
    },
    {
      code: "Hospital ID",
      name: "Hospital ID",
      width: "170px",
      omit: false,
      sortable: false,
      selector: (row) => `${row.hsplid}`,
    },

    {
      code: "Name",
      name: "Name",
      width: "400px",
      wrap:true,
      omit: false,
      sortable: false,
      selector: (row) => `${row.hsplName}`,
    },
    {
      code: "Address",
      name: "Address",
      width: "400px",
      wrap:true,
      sortable: false,
      selector: (row) => `${row.address}`,
    },
    {
      code: "Pin Code",
      name: "Pin Code",
      sortable: false,
      selector: (row) => `${row.pincode}`,
    },
  ];
  const { t } = useTranslation();

  return (
    <>
      <div className="jana_pmhospital_sec jana_news_sec">
        <TopBanner
          text={t("ABPMJAYHospital")}
          homeText={t("Home")}
          firstText={t("PMBJP")}
          secondaryText={t("ABPMJAYHospital")}
        />
        <div className="container ">
          <Tabs />
          <div className=" tab-content mt-5" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pmbi-tab5-data"
              role="tabpanel"
              aria-labelledby="pmbi-tab5"
            >
              <div className="jana_aboutus_data">
                <div className="row tabledropdown ">
                  <h3 id="headingColor">{t("ABPMJAYHospitalheading")}</h3>
                  <div class="col-md-3 mb-3">
                    <div class="form-group">

                      <Select
                        labelName={t("hospitalType")}
                        selectLabel={t("hospitalType")}
                        selectClass=""
                        handleSelect={handleSelect}
                        optionValue="hospitalType"
                        optionName="hospitalType"
                        moduleName="Pmhospital"
                        name="hsplType"
                        selectedValue={payload?.hsplType}
                        array={[{
                          hospitalType: 'GOI'
                        },
                        { hospitalType: 'PRIVATE' },
                        { hospitalType: 'PUBLIC' },
                        ]}
                        accsessablityId="headingColor"
                      />
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <div class="form-group">

                      <Select
                        labelName={t("selectstate")}
                        selectLabel={t("state")}
                        handleSelect={handleSelect}
                        optionValue="stateCode"
                        optionName="stateNameInEnglish"
                        name="state"
                        moduleName="Pmhospital"
                        selectedValue={payload?.state}
                        array={allState}
                        accsessablityId="headingColor"
                      />
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <div class="form-group">

                      <Select
                        labelName={t("selectdistrict")}
                        selectLabel={t("district")}
                        handleSelect={handleSelect}
                        optionValue="districtCode"
                        name="district"
                        moduleName="Pmhospital"
                        selectedValue={payload?.district}
                        optionName="districtNameInEnglish"
                        array={allDistrict}
                        accsessablityId="headingColor"
                      />

                    </div>
                  </div>

                  <div className="col-md-3 mb-3">
                    <div className="mt-2">
                      <button
                        class="btn blue-bg text-white mt-md-4 mt-lg-4 px-5"
                        type="button"
                        onClick={handleSerach}
                      >
                        {t("searchbutton")}
                      </button>
                    </div>

                  </div>
                  <div className=" mt-2">
                    <AdminDataTable
                      _tblColumns={tblColumns}
                      _rowData={rowData}
                      tableCustomStyles={tableCustomStyles}
                      _totalRows={totalElement}
                      setPage={setPage}
                      setPageSize={setPageSize}
                      pending={pending}
                      setPending={setPending}
                      setIsSearchTriggered={setIsSearchTriggered}

                    />
                  </div>
                  {/* {rowData?.length === 0 && (
                    <div className="mb-5">
                      <RecordNotfound />
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default PmHospital;
